import { FC } from 'react';

import { AnimatePresence } from 'framer-motion';

// TODO: add back error handling
export const ToastBox: FC = ({ children }) => <AnimatePresence>{children}</AnimatePresence>;
